function readStoredArray(key) {
    try {
        const value = JSON.parse(localStorage.getItem(key) || '[]')
        return Array.isArray(value) ? value : []
    } catch (error) {
        return []
    }
}

function readStoredBoolean(key) {
    try {
        return JSON.parse(localStorage.getItem(key) || 'false') === true
    } catch (error) {
        return false
    }
}

window.ORDER_PAGE_ROUTE_HELPERS = {
    hasSelectedService() {
        return this.currServOpt !== 'min' && !!this.getService(this.currServOpt)
    },

    hasSelectedCountry() {
        return this.currentCountry !== '' && !!this.getCountryBySN(this.currentCountry)
    },

    clearPageNotFoundOnValidSelection() {
        if (this.pageNotFound && (this.hasSelectedService() || this.hasSelectedCountry())) {
            this.pageNotFound = false
        }
    },

    getRouteSelections() {
        return {
            service: this.hasSelectedService() ? this.getService(this.currServOpt) : false,
            country: this.hasSelectedCountry() ? this.getCountryBySN(this.currentCountry) : false,
        }
    },

    getLocalizedPrefixPath() {
        if (this.currentLang && this.currentLang != 'false' && this.currentLang != 'en') {
            return '/' + this.currentLang
        }

        return ''
    },

    extractUrlParamsFromLocation(fullURL = window.location.href) {
        const separateUrl = fullURL.split('?')
        const getParamsUrl = separateUrl[1] ? separateUrl[1] : ''
        const explodedURL = separateUrl[0] ? separateUrl[0].split('/') : fullURL.split('?')

        let urlParams = {}
        let itsKey = false

        if (getParamsUrl) {
            this.currentGetParams = "?" + getParamsUrl
        }

        for (let i = 0; i < explodedURL.length; i++) {
            if (itsKey) {
                urlParams[explodedURL[i - 1]] = explodedURL[i]
                itsKey = false
            }

            if (explodedURL[i] == 'service' || explodedURL[i] == 'country') {
                itsKey = true
            }
        }

        return urlParams
    },

    async updatePageTitle() {
        const { service, country } = this.getRouteSelections()

        if (this.pageNotFound) {
            document.title = this.pageNotFoundTitle
            return
        }

        if (!service && !country) {
            document.title = $L('ords.title_acc_active_sms_serv')
        } else if (!service && country) {
            let documentTitle = ''

            if (this.currentCountry == "US") {
                documentTitle = $L('ords.title_temp_num_in_country')
            } else {
                documentTitle = $L('ords.title_recive_sms_from_country')
            }

            documentTitle = documentTitle.replace('{countryName}', country.title_country)
            document.title = documentTitle
        } else if (service && !country) {
            let docTitle = $L('ords.title_receive_sms_online_service')
            document.title = docTitle.replace('{serviceName}', service.service_name)
        } else {
            let titleSlugKey = "mainpage.slug_meta_title__" + this.currentSlug

            if (this.currentSlug && titleSlugKey !== $L(titleSlugKey)) {
                document.title = $L(titleSlugKey)
                    .replaceAll("{SERVICE}", service.service_name)
                    .replaceAll("{COUNTRY}", country.title_country)
            } else {
                let docTitle = $L('ords.title_temporar_num_serv_country')
                docTitle = docTitle.replace('{serviceName}', service.service_name)
                document.title = docTitle.replace('{countryName}', country.title_country)
            }
        }
    },

    async updateURL() {
        const { service, country } = this.getRouteSelections()

        const currentURL = window.location.origin
        const currentServ = service ? ('/service/' + service.url_service_name) : ''
        const currentContr = country ? ('/country/' + country.url_country_name) : ''

        let slugUrl = ''

        if (currentServ.length > 0 && currentContr.length > 0 && this.currentSlug) {
            slugUrl = '/' + this.currentSlug
        }

        window.history.pushState({}, '', currentURL + this.getLocalizedPrefixPath() + currentServ + currentContr + slugUrl + this.currentGetParams)
    },

    async checkURL() {
        const urlParams = this.extractUrlParamsFromLocation()

        if (!(urlParams && (urlParams.hasOwnProperty('service') || urlParams.hasOwnProperty('country')))) {
            return
        }

        const foundService = urlParams.hasOwnProperty('service')
            ? this.getServiceByUrl(urlParams.service)
            : false
        const foundCountry = urlParams.hasOwnProperty('country')
            ? this.getCountryByUrl(urlParams.country)
            : false

        if (this.isUserLoggedIn) {
            if (foundService) {
                this.currServOpt = foundService.service_opt
            }

            if (foundCountry) {
                this.currentCountry = foundCountry.shortname
            }

            if (
                (urlParams.hasOwnProperty('service') && !foundService) ||
                (urlParams.hasOwnProperty('country') && !foundCountry)
            ) {
                this.cleanupInvalidUrl = true
            }

            return
        }

        if (
            (urlParams.hasOwnProperty('service') && !foundService) ||
            (urlParams.hasOwnProperty('country') && !foundCountry)
        ) {
            this.pageNotFound = true
            document.title = this.pageNotFoundTitle
            return
        }

        if (foundService) {
            this.currServOpt = foundService.service_opt
        }

        if (foundCountry) {
            this.currentCountry = foundCountry.shortname
        }
    }
}

window.ORDER_PAGE_INIT_HELPERS = {
    async created() {
        this.currServOpt = 'min'
        this.countryPushP()
        this.easyBuyEmail = localStorage.getItem('easyBuyEmail') || ''
        this.reverseMode = localStorage.getItem('reverseMode') == 'true' ? true : false

        if (localStorage.getItem('typeNumbers')) {
            this.typeNumbers = localStorage.getItem('typeNumbers')
        }

        if (!this.isUserLoggedIn) {
            this.typeNumbers = this.typesNumbers.SMS.type
        }

        await this.checkURL()
        if (this.cleanupInvalidUrl) {
            await this.updateURL()
        }

        this.filterCountryF()

        if (this.pageNotFound) {
            document.title = this.pageNotFoundTitle
        } else if (this.currServOpt === 'min' && this.currentCountry === '') {
            this.mainLoaded = true
        } else if (this.isUserLoggedIn && this.currServOpt === 'min' && this.currentCountry !== '' && !this.reverseMode) {
            this.mainLoaded = true
        }

        this.popup.title = this.popupTitle[this.popupVariants.notLike]
        this.popup.variantPopup = this.popupVariants.notLike

        if (this.isUserLoggedIn) {
            this.favoritesCountry = readStoredArray('favorites_country')
            this.favoritesService = readStoredArray('simsms_favs')
            this.showFavorites = readStoredBoolean('showCountryFavorites') && this.favoritesCountry.length > 0

            if (!this.showFavorites) {
                localStorage.setItem('showCountryFavorites', 'false')
            }
        }

        Object.assign(this.topServicesFiltered, this.topServicesOpts)
        this.checkServiceFromOther(true)
        this.bindVisibilityChangeHandler()
        this.checkDropDownElements()
    },

    bindVisibilityChangeHandler() {
        document.addEventListener("visibilitychange", async function() {
            if (document.hidden) {
                this.stopRequests = true
            } else {
                let curOrders = {}

                if (this.orders && this.orders.length > 0) {
                    curOrders = await this.api.getActiveOrders()
                }

                if (curOrders && curOrders.status && curOrders.orders) {
                    let ordersArr = curOrders.orders

                    for (let q = 0; q < this.orders.length; q++) {
                        let curElEdit = false

                        for (let i = 0; i < ordersArr.length; i++) {
                            if (this.orders[q].id == ordersArr[i].id) {
                                this.orders[q].setTimer = ordersArr[i].secondsleft
                                curElEdit = true
                            }
                        }

                        if (!curElEdit) {
                            this.orders[q].setTimer = 0
                        }
                    }
                } else if (this.orders && this.orders.length > 0) {
                    for (let q = 0; q < this.orders.length; q++) {
                        this.orders[q].setTimer = 0
                    }
                }

                this.stopRequests = false
            }
        }.bind(this))
    },

    async mounted() {
        this.allServices.sort((a, b) => {
            let serviceA = a.service_name.toUpperCase()
            let serviceB = b.service_name.toUpperCase()

            if (serviceA < serviceB) {
                return -1
            }
            if (serviceA > serviceB) {
                return 1
            }
            return 0
        })

        await this.startTimer()

        window.addEventListener('resize', this.updateScreenWidth)
        await this.updateScreenWidth()

        this.muted = localStorage.getItem('isMuted')

        if (localStorage.getItem('countrySort')) {
            this.sorting = parseInt(localStorage.getItem('countrySort'))
        }

        if (this.isUserLoggedIn) {
            await this.updateActiveOrders()

            if (localStorage.getItem('isMuted')) {
                this.muted = localStorage.getItem('isMuted') === 'true'
            }
            this.showFavoritesServices = localStorage.getItem('showFavServices') === 'true'

            if (Array.isArray(this.favoritesService)) {
                const validFavorites = this.favoritesService.filter((opt) => !!this.getService(opt))

                if (validFavorites.length !== this.favoritesService.length) {
                    this.favoritesService = validFavorites
                    localStorage.setItem('simsms_favs', JSON.stringify(validFavorites))
                }
            }

            if (this.showFavoritesServices && this.favoritesService.length === 0) {
                this.showFavoritesServices = false
                localStorage.setItem('showFavServices', 'false')
            }
        }

        window.addEventListener('tick', this.updateCurrentCombo)
    },

    beforeDestroy() {
        window.removeEventListener('resize', this.updateScreenWidth)
        window.removeEventListener('tick', this.updateCurrentCombo)
    }
}
